const divModalAction = {
  fileError: 'Espere a que se carguen todos los archivos'
};

export default divModalAction;
